module.exports = __webpack_public_path__ + "static/media/ic_arrow_down_category.fbde13b9.svg";